import React from 'react'
import PropTypes from 'prop-types'
import WrapCheckbox from './WrapCheckbox'
import ListItem from 'material-ui/List/ListItem'
import {Field} from 'redux-form'
import SubListOfCheckboxes from './SubListOfCheckboxes'

class CheckboxItem extends React.Component {
    
    constructor(){
        super()
        this.state = { showSub: false }
    }

    checkboxOnChange(e){
        this.setState({ showSub: e.target.checked })
        if (!e.target.checked && this.props.subAnswers){
            this.props.subAnswers.map(subAnswer=>{
                this.props.changeFieldValue(subAnswer.field,false)
            })
        }
    }

    render(){
        return (
            <ListItem disableGutters={true} dense={true}>
                <div className='container'>
                    <div className='row'>
                        <Field 
                        name={this.props.field}
                        component={WrapCheckbox}
                        label={this.props.label}
                        onChange={this.checkboxOnChange.bind(this)}
                        />
                   </div>
                   {this.state.showSub && this.props.subAnswers?(
                   <div className='row' >
                       <div style={{paddingLeft: '50px'}}>
                          <SubListOfCheckboxes 
                            subQuestion={this.props.subQuestion}  
                            subAnswers={this.props.subAnswers}
                            changeFieldValue={this.props.changeFieldValue} />
                       </div>
                   </div>  
                   ):null}
                </div>
            </ListItem>    
        )
    }
}

CheckboxItem.propTypes = {
    field: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subAnswers: PropTypes.array
}

export default CheckboxItem


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/CheckboxItem.js